import {Component, OnInit, ViewChild} from '@angular/core';
import {Globals} from '../../../globals';
import {OperatoriesService} from './operatories.service';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {OperatoryDataModel} from '../../../models/clients/operatory-data.model';
import {TdoColorPickerEvent} from '../../../tdo-controls/common/tdo-color-picker/models/tdo-color-picker.event';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {TdoImagePickerEvent} from '../../../tdo-controls/common/tdo-image-picker/model/tdo-image-picker.event';
import {DialogService} from '../../../services/dialog.service';
import {ConfigurationService} from '../configuration.service';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';

@Component({
  selector: 'app-operatories',
  templateUrl: './operatories.component.html',
  styleUrls: ['./operatories.component.css']
})
export class OperatoriesComponent implements OnInit {
  @ViewChild('opTable') opTable: TdoTableV2Component;

  clientList: TdoClientConfigurationModel[];
  locationList: ClientLocationDataModel[];
  operatoriesList: OperatoryDataModel[];

  selectedClient: TdoClientConfigurationModel;
  selectedLocation: ClientLocationDataModel;
  selectedOperatory: OperatoryDataModel;
  editedOperatories: OperatoryDataModel[] = [];

  saveIndicatorVisible: boolean = false;
  saveButtonText: string = 'Save';
  isBusy: boolean = true;

  defaultColor = '#ffffff';
  imageDataSource: string[];

  constructor(private opsService: OperatoriesService,
              private globals: Globals,
              private dialogService: DialogService,
              private snackbar: MatSnackBar,
              public configurationService: ConfigurationService,
              private dialog: MatDialog) {
    this.imageDataSource = ['iconToothNew.svg', 'iconMedicalChair.svg', 'iconDoctorNew.svg', 'iconMicroscope.svg', 'iconMedicalBag.svg'];
  }

  get operatoryColor() {
    if (this.selectedOperatory.color) {
      return this.selectedOperatory.color;
    } else {
      return this.defaultColor;
    }
  }

  ngOnInit() {
    this.opsService.getClients().subscribe(data => {
      this.clientList = data;
      const currentClient = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
      if (currentClient) {
        this.selectedClient = currentClient;
      } else {
        this.selectedClient = this.clientList[0];
      }
      this.onChangeClient(this.selectedClient);
    }, err => {
      console.log(err);
      this.isBusy = false;
    });
  }

  onChangeClient(e: TdoClientConfigurationModel): void {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeClient(e);
          return;
        } else {
          this.opTable.selectionControl.select(this.selectedOperatory);
        }
      });
    } else {
      this.changeClient(e);
    }
  }

  changeClient(model: TdoClientConfigurationModel) {
    this.selectedClient = model;
    this.isBusy = true;

    this.opsService.getClientLocations(this.selectedClient.TDOCID.toString()).subscribe(ldata => {
      this.locationList = ldata;
      this.operatoriesList = null;
      this.selectedLocation = null;

      if (this.locationList.length > 0) {
        const currentLoc = this.locationList.find(p => p.LOCID.toString() === this.globals.LOCID);
        if (currentLoc) {
          this.selectedLocation = currentLoc;
        } else {
          this.selectedLocation = this.locationList[0];
        }
        this.onChangeLoc(this.selectedLocation);
      }
      this.isBusy = false;
    }, err => {
      console.log(err);
      this.isBusy = false;
    });
  }

  onChangeLoc(e) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.changeLoc(e);
          return;
        } else {
          this.opTable.selectionControl.select(this.selectedOperatory);
        }
      });
    } else {
      this.changeLoc(e);
    }
  }

  changeLoc(model: ClientLocationDataModel) {
    this.selectedLocation = model;
    this.operatoriesList = null;
    this.isBusy = true;
    this.opsService.getLocationOperatories(this.selectedLocation.LOCID.toString()).subscribe(odata => {
      this.operatoriesList = odata;
      this.operatoriesList.sort((a, b) => a.OperatoryOrder - b.OperatoryOrder);
      this.opTable.updateData(this.operatoriesList);
      this.selectedOperatory = this.operatoriesList[0];
      if (this.operatoriesList.length > 0) {
        setTimeout(() => {
          this.opTable.selectionControl.select(this.operatoriesList[0]);
        }, 200);
      }
      this.isBusy = false;
    }, err => {
      console.log(err);
      this.isBusy = false;
    });
  }

  addToEditedOperatories(operatory: OperatoryDataModel): void {
    this.configurationService.setDirty();
    if (!this.editedOperatories.includes(operatory)) {
      this.editedOperatories.push(operatory);
    }
  }

  onColorChange(event: TdoColorPickerEvent): void {
    this.selectedOperatory.color = event.hex.toString();
    this.addToEditedOperatories(this.selectedOperatory);
  }

  onImageChange(event: TdoImagePickerEvent): void {
    this.selectedOperatory.avatar = event.imageName;
    this.addToEditedOperatories(this.selectedOperatory);
  }

  onOperatoryChange(event): void {
    this.addToEditedOperatories(this.selectedOperatory);
    this.configurationService.setDirty();
  }

  onNew(e) {
    const operatory = new OperatoryDataModel();
    operatory.LOCID = this.selectedLocation.LOCID;
    operatory.OperatoryOrder = this.selectedOperatory.OperatoryOrder + 1;
    operatory.OperatoryName = 'New Operatory';
    operatory.color = '#0062a5';
    operatory.OperatoryDescription = '';
    this.selectedOperatory = operatory;
    this.operatoriesList.push(operatory);

    this.opTable.updateData(this.operatoriesList);
  }

  onSave(e) {
    if (this.editedOperatories.length === 0) {
      this.snackbar.open('No changes to save.', '', {duration: 5000});
    }

    this.saveIndicatorVisible = true;
    this.saveButtonText = 'Saving ...';
    this.isBusy = true;

    this.opsService.saveOperatories(this.editedOperatories).subscribe((newOperatories) => {

      this.changeLoc(this.selectedLocation);

      this.isBusy = false;
      // for (const model of newOperatories) {
      //   this.operatoriesList.push(model);
      // }
      this.editedOperatories = [];

      this.snackbar.open('Operatory save successful', '', {duration: 5000});
    }, err => {
      this.isBusy = false;
      this.snackbar.open('Operatory save failed', '', {duration: 5000});
    });
  }

  deleteOperatory(model: OperatoryDataModel) {
    this.opsService.deleteOperatory(model).subscribe((resp) => {
      if (this.editedOperatories.includes(model)) {
        const eidx = this.editedOperatories.findIndex(p => p.OperatoryId === model.OperatoryId);
        if (eidx > -1) {
          this.editedOperatories.splice(eidx, 1);
        }
      }
      const idx = this.operatoriesList.findIndex(p => p.OperatoryId === model.OperatoryId);
      if (idx > -1) {
        this.operatoriesList.splice(idx, 1);
        if (this.operatoriesList.length > 0) {
          this.selectedOperatory = this.operatoriesList[0];
        }
      }

      this.opTable.updateData(this.operatoriesList);
      this.snackbar.open(`Operatory ${model.OperatoryName} delete success`, '', {duration: 5000});
    }, error => {
      this.snackbar.open(`Failed to delete operatory ${model.OperatoryName}`, '', {duration: 5000});
    });
  }

  onDeleteOperatory(op: OperatoryDataModel) {
    const model = op;
    this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.OperatoryName}?`).subscribe((result) => {
      if (result === true) {
        this.deleteOperatory(model);
      } else {
        //
      }
    });
  }

  onRowSelected($event: TdoTableSelectionEvent) {
    this.selectedOperatory = $event.model;
  }
}
